export const FILE_UPLOAD_IMAGES_ALLOWED_MIME_TYPES =
  "image/png, image/jpeg, image/bmp";

export const FILE_UPLOAD_IMAGES_ALLOWED_MB_SIZE = 4;
